/*jshint esversion: 6 */

import React from 'react';

const CaQuizzesBannerView = (props) => {
    const { title,description,image,cta, ctaCallback } = props;

    return(
        <div className={"QuizzesBanner"} >
            <div className={"QuizzesBanner__innerBg"} style={{backgroundImage:"url("+image+")"}} >
            </div>
            <div className={"QuizzesBanner__innerShade"} />
            <div className={"QuizzesBanner__inner"}>
                <div className={"QuizzesBanner__content"}>
                    <h3 className={"QuizzesBanner__title"}>{title}</h3>
                    <p className={"QuizzesBanner__description"}>{description}</p>
                    { !!cta && <div className={"QuizzesBanner__buttonWrapper"}>
                        <button className={"QuizzesBanner__submitButton"} onClick={()=>ctaCallback()}>{cta}</button>
                    </div> }
                </div>
            </div>
        </div>
    );
};
export default CaQuizzesBannerView;





